module.exports = __webpack_public_path__ + "7ab4ce0d74c1366fa99b6ed8eba60bf5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-0.png
// module id = 3098
// module chunks = 0